import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Result } from 'app/main/shared/result';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StartupPageService {

  constructor(private http: HttpClient) { }

  public StoreSessionData(data: any) {
    return this.http.post<Result>(`${environment.apiUrl}/LoginManagement/StorePNSSessionData`, data);
  }

  public GetLandingPageURL(data: any) {
    return this.http.post<Result>(`${environment.apiUrl}/LoginManagement/StorePNSSessionData`, data);
  }

  public StoreUserStorage(data: any) {
    return this.http.post<Result>(`${environment.apiUrl}/LoginManagement/StoreUserStorage`, data);
  }
}
